import React from 'react';

const sassStyles = require('./styles.scss');

const Header = ({className, title, subTitle}) => (
  <div className={`${sassStyles.header} ${className ? className : ''}`}>
    <h4 className={sassStyles.title}>{title}</h4>
    {subTitle && <span className={sassStyles.subTitle}>{subTitle}</span>}
  </div>
);

export default Header;
